import React, { useState } from "react";
import { useForm } from "../../hooks/useForm";
import "../../pages/Users/Users.css"; // Reusing some user form styles

const TS_HELP_TEXT =
  "סימון התיבה מגדיר את הפריט כפריט הדורש מספר סידורי (צ') לכל יחידה: במלאי ובחתימה כל פריט מזוהה במספר מזהה משלו. כשהתיבה לא מסומנת, הפריט נספר לפי כמות בלבד (לרוב עם הבחנה אורגני/קווי), בלי מספר סידורי לכל יחידה.";

const ItemsForm = ({
  initialValues,
  onSubmit,
  onCancel,
  submitText,
  isEditing,
}) => {
  const [showTsHelp, setShowTsHelp] = useState(false);

  const validationRules = {
    itemName: (value) => (value ? "" : "שם הפריט הוא שדה חובה"),
    note: (value) => "", // Note is optional
  };

  const { values, errors, handleChange, setFieldValue } = useForm(
    initialValues,
    validationRules
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(values);
  };

  return (
    <form onSubmit={handleSubmit} className="personnel-form">
      <div className="form-group">
        <label htmlFor="itemName">שם הפריט:</label>
        <input
          type="text"
          id="itemName"
          name="itemName"
          value={values.itemName}
          onChange={handleChange}
          className={errors.itemName ? "error-input" : ""}
          placeholder="הזן שם פריט"
        />
        {errors.itemName && <p className="error-message">{errors.itemName}</p>}
      </div>

      <div className="form-group items-form-ts-group">
        <div className="items-form-ts-row">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="isChecked"
              checked={values.isChecked || false}
              onChange={(e) => setFieldValue("isChecked", e.target.checked)}
            />
            <span className="checkbox-text">צ'</span>
          </label>
          <span className="items-ts-inline-hint">סמן אם לפריט יש מספר סידורי</span>
          {!isEditing && (
            <button
              type="button"
              className="items-ts-help-trigger"
              onClick={() => setShowTsHelp((open) => !open)}
              aria-expanded={showTsHelp}
              aria-controls="items-ts-help-panel"
              title="הסבר על מצפין / מספר סידורי"
            >
              ?
            </button>
          )}
        </div>
        {!isEditing && showTsHelp && (
          <div
            id="items-ts-help-panel"
            className="items-ts-help-panel"
            role="region"
            aria-live="polite"
          >
            {TS_HELP_TEXT}
          </div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="makat">מק"ט (אופציונלי):</label>
        <input
          type="text"
          id="makat"
          name="makat"
          value={values.makat || ""}
          onChange={handleChange}
          placeholder="הזן מק&quot;ט"
        />
      </div>

      <div className="form-group">
        <label htmlFor="note">הערה:</label>
        <textarea
          id="note"
          name="note"
          value={values.note}
          onChange={handleChange}
          className={errors.note ? "error-input" : ""}
          placeholder="הזן הערה (אופציונלי)"
          rows="3"
          style={{
            padding: "12px 16px",
            border: "2px solid #e2e8f0",
            borderRadius: "8px",
            fontSize: "16px",
            textAlign: "right",
            transition: "all 0.3s ease",
            resize: "vertical",
            minHeight: "80px",
            fontFamily: "inherit",
          }}
        />
        {errors.note && <p className="error-message">{errors.note}</p>}
      </div>

      <div className="form-actions">
        <button type="submit" className="save-btn">
          {submitText}
        </button>
        <button type="button" onClick={onCancel} className="cancel-btn">
          ביטול
        </button>
      </div>
    </form>
  );
};

export default ItemsForm;
